var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":function($event){return _vm.$emit('back')}}},[_c('r-icon',{attrs:{"name":"arrow-back","size":18}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }